module.exports = __webpack_public_path__ + "static/img/header.d21992bb.png";